import React, { Component } from 'react';
import { Col, Row, Grid, Table, ButtonToolbar, Button, Tabs, Tab, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

import { ComparisonHelper } from '../../helpers/ComparisonHelper';

import { PassingTimesForm } from './PassingTimesForm';
import { PassingTimesActive } from './PassingTimesActive';
import { PassingTimesDraft } from './PassingTimesDraft';
import { Intervals } from '../intervals/Intervals';
import { TripNotes } from '../notes/TripNotes';

import { TripsCommand } from '../commands/TripsCommand';
import { TripsDraftCommand } from '../commands/TripsDraftCommand';
import { LineAPI } from '../../../api/datamanager/LineAPI';
import { PathAPI } from '../../../api/datamanager/PathAPI';
import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';
import { ScheduleAPI } from '../../../api/datamanager/ScheduleAPI';
import { TripAPI } from '../../../api/datamanager/TripAPI';

export class PassingTimes extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            isComparing: false,
            draftComparePathStops: [],
            draftCompareTrips: [],

            loadingEdition: false,
            selectedTab: "active",
            formType: "active",

            renderTable: false,
            actionsActive: {
                loadingLines: true,
                loadingPathStops: false,
                loadingSchedules: true,
                loadingTrips: false
            },
            actionsDraft: {
                loadingLines: true,
                loadingPaths: false,
                loadingPathStops: false,
                loadingSchedules: true,
                loadingTrips: false
            },

            showIntervals: false,
            intervalsTripId: 0,
            intervalsCommand: undefined,

            showNotes: false,
            notesTripId: 0,
            notesCommand: undefined,

            showMoveCopyModal: false,
            modalTripId: 0,
            moveCommand: undefined,
            copyCommand: undefined,
            moveableSchedules: [],
            modalScheduleSelected: undefined,
            modalTitleText: undefined,
            modalButtonText: undefined,
            modalCallback: undefined,

            tripSelected: undefined,

            activeLines: [],
            activeLinePaths: [],
            activePathSelectedPathStops: [],
            activePathTrips: [],
            activeSchedules: [],
            activeTrips: [],
            activeTripsToChange: [],
            activeTripsToDelete: [],

            activeLineSelected: undefined,
            activePathSelected: undefined,
            activeScheduleSelected: undefined,

            draftLines: [],
            draftLinePaths: [],
            draftPathSelectedPathStops: [],
            draftPathTrips: [],
            draftSchedules: [],
            draftTrips: [],
            draftTripsToChange: [],
            draftTripsToDelete: [],

            draftLineSelected: undefined,
            draftPathSelected: undefined,
            draftScheduleSelected: undefined,

            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            alertArgument: undefined,
            icon: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            errorLoading: false,
            showDeleteModal: false,
            showCreateModal: false,
            showExecutingModal: false,
            showPropBtn: false,
            newTripId: -1,
            editTripName: 0,
            typeOfPass: "",
            passFreq: "",
            justVerify: false,
            freqInputError: null
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);

        document.addEventListener("keydown", (e) => this.onKeyPress(e), false);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    onKeyPress(event) {
        let keys = [13, 27];
        let keyPressed = keys.find(function (element) {
            return element === event.keyCode;
        });

        if (keyPressed !== undefined) {
            this.setState({ editTripName: 0 });
        }
    }

    onDoubleClickTrip(tripID, e) {
        this.setState({ editTripName: tripID });
    }

    // ----------------------

    startUpdate() {
        this.setState({
            loadingEdition: true
        });
    }

    endUpdate() {
        this.setState({
            loadingEdition: false
        });
    }

    updateNetwork() {
        const { actionsActive } = this.state;
        actionsActive.loadingLines = true;

        this.setState({
            actionsActive: actionsActive
        }, () => {
            this.getActiveLines(this.context.edition);
        });
    }

    updateDraftNetwork() {
        const { actionsDraft } = this.state;
        actionsDraft.loadingLines = true;

        this.setState({
            actionsDraft: actionsDraft
        }, () => {
            this.getDraftLines(this.context.edition);
        });
    }

    updatePlanning() {
        const { actionsActive } = this.state;
        actionsActive.loadingSchedules = true;

        this.setState({
            actionsActive: actionsActive
        }, () => {
            this.getActiveSchedules(this.context.edition);
        });
    }

    updateDraftPlanning() {
        const { actionsDraft } = this.state;
        actionsDraft.loadingSchedules = true;

        this.setState({
            actionsDraft: actionsDraft
        }, () => {
            this.getDraftSchedules(this.context.edition);
        });
    }

    // -------------------

    getActiveLines(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        LineAPI.list(edition.network, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsActive } = this.state;
                actionsActive.loadingLines = false;

                this.setState({
                    activeLines: data,
                    actionsActive: actionsActive,
                    showExecutingModal: false,
                    freqInputError: null,
                }, () => this.updateLineForm());
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getDraftLines(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { draftLineSelected } = this.state;
        const lineSelectedId = undefined !== draftLineSelected ? draftLineSelected.id : undefined;

        LineAPI.listWithActiveDraft(edition.network, edition.draftNetwork, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsDraft } = this.state;
                actionsDraft.loadingLines = false;

                this.setState({
                    draftLines: data,
                    actionsDraft: actionsDraft,
                    showExecutingModal: false,
                    draftLineSelected: data.find(line => line.id === lineSelectedId),
                    freqInputError: null,
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getDraftPaths(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { draftLineSelected } = this.state;

        PathAPI.listByLineWithActiveDraft(edition.network, edition.draftNetwork, draftLineSelected.id, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsDraft } = this.state;
                actionsDraft.loadingPaths = false;

                this.setState({
                    draftLinePaths: data,
                    actionsDraft: actionsDraft
                });
            }).catch((err) => {
                this.setState({
                    draftLinePaths: [],
                    loadingDraftPaths: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getActivePathStops(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { activePathSelected } = this.state;

        PathStopAPI.listByPath(edition.network, activePathSelected.id, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsActive } = this.state;
                actionsActive.loadingPathStops = false;

                this.setState({
                    activePathSelectedPathStops: data,
                    actionsActive: actionsActive,
                    showExecutingModal: false
                }, () => {
                    this.getPathStopsToCompare(edition, activePathSelected);
                    this.orderListActive('pathSelectedPathStops');
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getPathStopsToCompare(edition, pathSelected) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        PathStopAPI.listByPathCodeDraft(edition.draftNetwork, pathSelected.code, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({ draftComparePathStops: data });
            })
            .catch(_ => _); // This is stupid but it prevents from throwing an exception
    }

    getDraftPathStops(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { draftPathSelected } = this.state;

        PathStopAPI.listByPathWithActiveDraft(edition.network, edition.draftNetwork, draftPathSelected.id, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsDraft } = this.state;
                actionsDraft.loadingPathStops = false;

                this.setState({
                    draftPathSelectedPathStops: data,
                    actionsDraft: actionsDraft,
                    showExecutingModal: false
                }, () => {
                    this.orderListDraft('pathSelectedPathStops');
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getActiveSchedules(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        ScheduleAPI.list(edition.planning, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsActive } = this.state;
                actionsActive.loadingSchedules = false;

                this.setState({
                    activeSchedules: data,
                    actionsActive: actionsActive,
                    showExecutingModal: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getDraftSchedules(edition) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { draftScheduleSelected } = this.state;
        const scheduleSelectedId = undefined !== draftScheduleSelected ? draftScheduleSelected.id : undefined;

        ScheduleAPI.listDraft(edition.draftPlanning, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const { actionsDraft } = this.state;
                actionsDraft.loadingSchedules = false;

                this.setState({
                    draftSchedules: data,
                    actionsDraft: actionsDraft,
                    draftScheduleSelected: data.find(sched => sched.id === scheduleSelectedId),
                    showExecutingModal: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    getActiveTrips(edition) {
        const { activeScheduleSelected, activePathSelected } = this.state;

        if (undefined === activeScheduleSelected) {
            return;
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { tripSelected } = this.state;
        const tripSelectedId = undefined !== tripSelected ? tripSelected.id : undefined;

        TripAPI.loadByPathAndSched(edition.network, edition.planning, activePathSelected.id, activeScheduleSelected.id, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    showDeleteModal: false,
                    showExecutingModal: false,
                    activeTrips: data,
                    tripSelected: data.find(trip => trip.id === tripSelectedId)
                }, () => {
                    const { actionsActive, activeTrips, activePathSelected } = this.state;
                    actionsActive.loadingTrips = false;

                    if (undefined !== activePathSelected) {
                        this.setState({
                            activePathTrips: activeTrips.filter(trip => trip.path.id === activePathSelected.id),
                            actionsActive: actionsActive
                        }, () => this.orderListActive('trips'));
                    }
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });

        TripAPI.loadByPathAndSchedCodeDraft(edition.network, edition.draftNetwork, edition.draftPlanning, activePathSelected.code, activeScheduleSelected.name, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({ draftCompareTrips: data });
            })
            .catch(_ => _); // This is stupid but it prevenvs form throwing an exception
    }

    getDraftTrips(edition) {
        const { draftScheduleSelected, draftPathSelected } = this.state;

        if (undefined === draftScheduleSelected) {
            return;
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { tripSelected } = this.state;
        const tripSelectedId = undefined !== tripSelected ? tripSelected.id : undefined;

        TripAPI.loadByPathAndSchedWithActiveDraft(edition.network, edition.draftNetwork, edition.draftPlanning, draftPathSelected.id, draftScheduleSelected.id, selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    showDeleteModal: false,
                    showExecutingModal: false,
                    draftTrips: data,
                    tripSelected: data.find(trip => trip.id === tripSelectedId)
                }, () => {
                    const { actionsDraft, draftTrips, draftPathSelected } = this.state;
                    actionsDraft.loadingTrips = false;

                    if (undefined !== draftTrips) {
                        this.setState({
                            draftPathTrips: draftTrips.filter(trip => trip.pathId === draftPathSelected.id),
                            actionsDraft: actionsDraft
                        }, () => this.orderListDraft('trips'));
                    }
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                });
            });
    }

    // -------------------

    callSaveApi(trips, callback) {
        return callback(trips)
            .catch((err) => {
                this.setState({
                    showExecutingModal: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    save() {
        this.setState({
            showExecutingModal: true,
            justVerify: false
        }, async () => {
            const { activeTripsToChange, draftTripsToChange, activeTripsToDelete,
                draftTripsToDelete, activeScheduleSelected, draftPathSelected } = this.state;
            const { edition } = this.context;

            if (0 === activeTripsToChange.length && 0 === draftTripsToChange.length
                && 0 === activeTripsToDelete.length && 0 === draftTripsToDelete.length) {

                this.setState({
                    showExecutingModal: false,
                    alertTitle: "Aviso",
                    alertMessage: 'Não existem alterações.',
                    alertStyle: 'warning',
                    icon: 'alert',
                    showErrorModal: true
                })

                return false;
            }

            let successActiveChange = true;
            let successDraftChange = true;
            let successActiveDelete = true;
            let successDraftDelete = true;

            const activeNameErrors = this.checkForNameErrors(activeTripsToChange, "name");
            const draftNameErrors = this.checkForNameErrors(draftTripsToChange, "code");

            if (activeNameErrors || draftNameErrors) {
                this.setState({
                    showExecutingModal: false,
                    alertTitle: "Aviso",
                    alertMessage: 'Todas as viagens têm que ter nome definido.',
                    alertStyle: 'warning',
                    icon: 'alert',
                    showErrorModal: true
                });

                return false;
            }

            if (!this.verifyActivePassings()) {
                return false;
            }

            if (!this.verifyDraftPassings()) {
                return false;
            }

            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            if (0 < activeTripsToChange.length) {
                successActiveChange = await this.callSaveApi(activeTripsToChange, (a) => { return TripAPI.update(edition.network, activeScheduleSelected.planningEdition, a, selectedProviderId) });
            }

            if (0 < activeTripsToDelete.length) {
                successActiveDelete = await this.callSaveApi(activeTripsToDelete, (a) => { return TripAPI.deleteTrips(edition.network, activeScheduleSelected.planningEdition, a) });
            }

            if (0 < draftTripsToChange.length) {
                successDraftChange = await this.callSaveApi(draftTripsToChange, (a) => { return TripAPI.updateDraft(draftPathSelected.networkEdition, edition.draftPlanning, a, selectedProviderId) });
            }

            if (0 < draftTripsToDelete.length) {
                successDraftDelete = await this.callSaveApi(draftTripsToDelete, (a) => { return TripAPI.deleteDraftTrips(draftPathSelected.networkEdition, edition.draftPlanning, a) });
            }

            if (successActiveChange && successActiveDelete && successDraftChange && successDraftDelete) {
                this.setState({
                    showErrorModal: true,
                    alertTitle: "Sucesso",
                    alertMessage: 'Alterações efetuadas com sucesso.',
                    alertStyle: 'success',
                    icon: 'ok'
                });

                const { actionsActive, actionsDraft } = this.state;

                actionsActive.loadingTrips = true;
                actionsDraft.loadingTrips = true;

                this.setState({
                    actionsActive: actionsActive,
                    actionsDraft: actionsDraft,
                    activeTripsToChange: [],
                    draftTripsToChange: [],
                    activeTripsToDelete: [],
                    draftTripsToDelete: [],
                    editTripName: 0
                });

                this.getActiveTrips(edition);
                this.getDraftTrips(edition);
            }

            this.setState({
                showExecutingModal: false,
            });
        });
    }

    deleteTrip(isToExecute, argument) {
        this.setState({ showDeleteModal: false });

        if (!isToExecute) {
            return;
        }

        const { tripSelected, activePathTrips, draftPathTrips, activeTripsToDelete, draftTripsToDelete, activeTripsToChange, draftTripsToChange } = this.state;
        let pathTripsArr = [];
        let tripsToDeleteArr = [];
        let tripsToChangeArr = [];

        switch (argument) {
            case "active":
                pathTripsArr = activePathTrips;
                tripsToDeleteArr = activeTripsToDelete;
                tripsToChangeArr = activeTripsToChange;
                break;

            case "draft":
                pathTripsArr = draftPathTrips;
                tripsToDeleteArr = draftTripsToDelete;
                tripsToChangeArr = draftTripsToChange;
                break;

            default:
                this.setState({ showDeleteModal: false });
                return;
        }

        if (tripSelected.id > 0) {
            tripsToDeleteArr.push(tripSelected);
        }

        const pathTripsTripSelectedIdx = pathTripsArr.indexOf(pathTripsArr.find(trip => trip.id === tripSelected.id));
        if (-1 !== pathTripsTripSelectedIdx) {
            pathTripsArr.splice(pathTripsTripSelectedIdx, 1);

            const tripsToChangeTripSelectedIdx = tripsToChangeArr.indexOf(tripSelected);
            if (-1 !== tripsToChangeTripSelectedIdx) {
                tripsToChangeArr.splice(tripsToChangeTripSelectedIdx, 1);
            }
        }

        this.setState({
            activePathTrips: activePathTrips,
            draftPathTrips: draftPathTrips,
            activeTripsToDelete: activeTripsToDelete,
            draftTripsToDelete: draftTripsToDelete,
            activeTripsToChange: activeTripsToChange,
            draftTripsToChange: draftTripsToChange
        }, () => {
            this.orderListActive('trips');
            this.orderListDraft('trips');
        });
    }

    checkForNameErrors(tripsToChange, property) {
        let errors = false;

        if (tripsToChange.length > 0) {
            tripsToChange.map((trip) => undefined === trip[property] || null === trip[property] || "" === trip[property] ? errors = true : null);
        }

        return errors;
    }

    formatPassingHour(passing) {
        let isAlmostTime = new RegExp("^([0-9]{0,2}):([0-9]{0,3})$").test(passing.formatedHour);

        if (isAlmostTime) {
            let timeSpliter = passing.formatedHour.split(':');

            if (Number.isInteger(Number(timeSpliter[0])) && Number.isInteger(Number(timeSpliter[1]))) {
                let h = timeSpliter[0];
                let m = timeSpliter[1];

                if (h.length < 1) {
                    h = "00";
                } else {
                    if (h.length < 2) {
                        h = "0" + h;
                    }
                }

                if (m.length < 1) {
                    m = "00";
                } else {
                    if (m.length < 2) {
                        m = "0" + m;
                    }
                }

                passing.formatedHour = h + ":" + m;
            }
        }
    }

    verifyPassings(trip, tripsError) {
        const errors = {
            number: 0,
            trips: undefined === tripsError ? "" : tripsError
        };
        let lastPassingPositionToCheck = -1;

        trip.passings.forEach((pass, i) => {
            let isTime = new RegExp("^(0[0-9]|1[0-9]|2[0-9]|[0-9]):[0-5][0-9]$").test(pass.formatedHour);
            let isAlmostTime = false;

            if (pass.formatedHour !== ":") {
                isAlmostTime = new RegExp("^([0-9]{0,2}):([0-9]{0,3})$").test(pass.formatedHour);
            }

            if (!isTime) {
                if (isAlmostTime) {
                    let timeSpliter = pass.formatedHour.split(':');

                    if (Number.isInteger(Number(timeSpliter[0])) && Number.isInteger(Number(timeSpliter[1]))) {
                        let h = timeSpliter[0];
                        let m = timeSpliter[1];
                        let hToAdd = 0;
                        let mToAdd = 0;
                        let iniTime = trip.passings[i].formatedHour;

                        if (h.length < 1) {
                            h = "00";
                        } else {
                            if (h.length < 2) {
                                h = "0" + h;
                            }
                        }

                        if (m.length < 1) {
                            m = "00";
                        } else {
                            if (m.length < 2) {
                                m = m + "0";
                            } else {
                                if (Number(m) >= 60) {
                                    hToAdd = Math.floor(m / 60);
                                    mToAdd = m % 60;

                                    if (Number(hToAdd) + Number(h) > 9) {
                                        h = Number(hToAdd) + Number(h);
                                    } else {
                                        let hTotal = Number(hToAdd) + Number(h)
                                        h = "0" + hTotal;
                                    }

                                    if (mToAdd > 9) {
                                        m = mToAdd;
                                    } else {
                                        m = "0" + mToAdd;
                                    }
                                }
                            }
                        }
                        trip.passings[i].formatedHour = h + ":" + m;

                        if (!this.checkPassingTimes(trip.passings, i, lastPassingPositionToCheck)) {
                            const tripName = undefined === trip.name ? trip.code : trip.name;
                            tripsError.length > 0 ?
                                tripsError.includes(tripName) ?
                                    tripsError += "" :
                                    tripsError += ", " + tripName :
                                tripsError = tripName;

                            trip.passings[i].formatedHour = iniTime;
                            errors.number += 1;
                        } else {
                            trip.passings[i].hour = Number(h);
                            trip.passings[i].minute = Number(m);
                            trip.passings[i].time = Number(h * 60) + Number(m);

                            lastPassingPositionToCheck = i;
                        }
                    }
                }
            } else {
                if (!this.checkPassingTimes(trip.passings, i, lastPassingPositionToCheck)) {
                    const tripName = undefined === trip.name ? trip.code : trip.name;
                    "" !== errors.trips && undefined !== errors.trips && null !== errors.trips ?
                        errors.trips.includes(tripName) ?
                            errors.trips += "" :
                            errors.trips += ", " + tripName :
                        errors.trips = tripName;
                    errors.number += 1;
                }
                else {
                    lastPassingPositionToCheck = i;
                }
            }
        });

        return errors;
    }

    verifyActivePassings() {
        const { activeTripsToChange, activePathTrips, justVerify } = this.state;

        if (activePathTrips.length > 0) {
            if (justVerify !== true) {
                let containsErrors = 0;
                let tripsError = "";

                activePathTrips.forEach((trip) => {
                    trip.passings.sort((a, b) => a.pathStop.stopOrder - b.pathStop.stopOrder);
                    const errors = this.verifyPassings(trip, tripsError);

                    containsErrors += errors.number;
                    tripsError = errors.trips;
                });

                if (containsErrors !== 0) {
                    this.setState({
                        alertTitle: "Aviso",
                        alertMessage: tripsError.includes(",") ? 'As viagens ' + tripsError + " têm horas inválidas" : 'A viagem ' + tripsError + " tem horas inválidas",
                        alertStyle: 'warning',
                        icon: 'alert',
                        showErrorModal: true,
                        showExecutingModal: false
                    });
                    return false;
                }
            } else {
                activeTripsToChange.forEach((trip, i) => {
                    trip.passings.forEach((pass) => {
                        this.formatPassingHour(pass);
                    });

                    let tripIndex = activePathTrips.findIndex(pt => pt.id === activeTripsToChange[i].id);

                    if (tripIndex > 0) {
                        activePathTrips[tripIndex] = activeTripsToChange[i];
                    }
                });

                this.setState({
                    activePathTrips,
                    activeTripsToChange
                });
            }
        }

        return true;
    }

    verifyDraftPassings() {
        const { draftTripsToChange, draftPathTrips, justVerify } = this.state;

        if (draftTripsToChange.length > 0) {
            if (justVerify !== true) {
                let containsErrors = 0;
                let tripsError = "";

                draftPathTrips.forEach((trip) => {
                    trip.passings.sort((a, b) => a.pathStopOrder - b.pathStopOrder);
                    const errors = this.verifyPassings(trip, tripsError);

                    containsErrors += errors.number;
                    tripsError = errors.trips;
                });

                if (containsErrors !== 0) {
                    this.setState({
                        alertTitle: "Aviso",
                        alertMessage: tripsError.includes(",") ? 'As viagens ' + tripsError + " têm horas inválidas" : 'A viagem ' + tripsError + " tem horas inválidas",
                        alertStyle: 'warning',
                        icon: 'alert',
                        showErrorModal: true,
                        showExecutingModal: false
                    });
                    return false;
                }
            } else {
                draftTripsToChange.forEach((trip, i) => {
                    trip.passings.forEach((pass) => {
                        this.formatPassingHour(pass);
                    });

                    let tripIndex = draftPathTrips.findIndex(pt => pt.id === draftTripsToChange[i].id);

                    if (tripIndex > 0) {
                        draftPathTrips[tripIndex] = draftTripsToChange[i];
                    }
                });

                this.setState({
                    draftPathTrips,
                    draftTripsToChange
                });
            }
        }

        return true;
    }

    // -------------------

    updateLineForm() {
        const { activeLines, activeLineSelected } = this.state;

        if (undefined === activeLineSelected) {
            return;
        }

        this.handleActiveLineSelected(activeLines.find(x => x.code === activeLineSelected.code), true);
    }

    updatePathForm() {
        const { activeLinePaths, activePathSelected } = this.state;

        if (undefined === activePathSelected) {
            return;
        }

        this.handleActivePathSelected(activeLinePaths.find(x => x.code === activePathSelected.code), true);
    }

    updateScheduleForm() {
        const { activeSchedules, activeScheduleSelected } = this.state;

        if (undefined === activeScheduleSelected) {
            return;
        }

        this.handleActivSchedulesSelected(activeSchedules.find(x => x.code === activeScheduleSelected.code));
    }

    handleActiveLineSelected(e, updateForm = false) {
        if (undefined !== e && null !== e) {
            this.setState({
                activeLineSelected: e,
                activeLinePaths: e.paths,
                activeTripsToChange: [],
                activePathTrips: []
            }, () => {
                if (updateForm) {
                    this.updatePathForm();
                }
            });
        } else {
            this.setState({
                activeLineSelected: undefined,
                activeLinePaths: [],
                activePathSelected: undefined,
                activeScheduleSelected: undefined,
                activeTripsToChange: [],
                activePathTrips: []
            });
        }
    }

    handleDraftLineSelected(e) {
        if (undefined !== e && null !== e) {
            const { edition } = this.context;
            const { actionsDraft } = this.state;

            actionsDraft.loadingPaths = true;

            this.setState({
                draftLineSelected: e,
                draftPathSelected: undefined,
                draftScheduleSelected: undefined,
                draftTripsToChange: [],
                draftPathTrips: [],
                actionsDraft: actionsDraft
            }, () => this.getDraftPaths(edition));
        } else {
            this.setState({
                draftLineSelected: undefined,
                draftLinePaths: [],
                draftPathSelected: undefined,
                draftScheduleSelected: undefined,
                draftTripsToChange: [],
                draftPathTrips: []
            });
        }
    }

    handleActivePathSelected(e, updateForm = false) {
        const { edition } = this.context;

        if (undefined !== e && null != e) {
            this.setState({
                activePathSelected: e,
                activeScheduleSelected: undefined,
                activePathSelectedPathStops: [],
                activeTripsToChange: [],
                activePathTrips: []
            }, () => {
                this.getActivePathStops(edition);
                if (updateForm) {
                    this.updateScheduleForm();
                }
            });
        } else {
            this.setState({
                activePathSelected: undefined,
                activeScheduleSelected: undefined,
                activePathSelectedPathStops: [],
                activeTripsToChange: [],
                activePathTrips: []
            });
        }
    }

    handleDraftPathSelected(e) {
        const { edition } = this.context;

        if (undefined !== e && null !== e) {
            this.setState({
                draftPathSelected: e,
                draftScheduleSelected: undefined,
                draftPathSelectedPathStops: [],
                draftTripsToChange: [],
                draftPathTrips: []
            }, () => this.getDraftPathStops(edition));
        } else {
            this.setState({
                draftPathSelected: undefined,
                draftScheduleSelected: undefined,
                draftPathSelectedPathStops: [],
                draftTripsToChange: [],
                draftPathTrips: []
            });
        }
    }

    handleActiveScheduleSelected(e) {
        const { edition } = this.context;

        if (undefined !== e && null !== e) {
            const { actionsActive } = this.state;
            actionsActive.loadingTrips = true;

            this.setState({
                activeScheduleSelected: e,
                activeTripsToChange: [],
                activePathTrips: [],
                actionsActive: actionsActive,
                showPropBtn: false,
            }, () => {
                this.getActiveTrips(edition);
            });
        } else {
            this.setState({
                activePathTrips: [],
                activeScheduleSelected: undefined,
                activeTripsToChange: [],
                showPropBtn: false
            });
        }
    }

    handleDraftScheduleSelected(e) {
        const { edition } = this.context;

        if (undefined !== e && null !== e) {
            const { actionsDraft } = this.state;
            actionsDraft.loadingTrips = true;

            this.setState({
                draftScheduleSelected: e,
                draftTripsToChange: [],
                draftPathTrips: [],
                actionsDraft: actionsDraft
            }, () => {
                this.getDraftTrips(edition);
            });
        } else {
            this.setState({
                draftPathTrips: [],
                draftTripsToChange: [],
                draftScheduleSelected: undefined
            });
        }
    }

    handleCreateClick(formType) {
        this.setState({
            showCreateModal: true,
            formType: formType
        });
    }

    handleCancelClick() {
        this.setState({
            showCreateModal: false,
            typeOfPass: "",
            passFreq: 0
        });
    }

    handleDeleteClick(trip, type) {
        if (trip !== undefined && trip.id !== undefined) {
            const tripName = "draft" === type ? trip.code : trip.name;

            this.setState({
                tripSelected: trip,
                showDeleteModal: true,
                alertTitle: "Aviso",
                alertMessage: `Tem a certeza que pretende eliminar a viagem ${tripName}?`,
                alertStyle: "warning",
                alertArgument: type,
                icon: 'alert',
            })
        } else {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: 'Selecione um horário.',
                alertStyle: 'warning',
                alertArgument: undefined,
                icon: 'alert',
                showErrorModal: true
            })
        }
    }

    handleIntervalsClick(trip, type) {
        let intervalsCommand = undefined;
        switch (type) {
            case "active": intervalsCommand = new TripsCommand();
                break;

            case "draft": intervalsCommand = new TripsDraftCommand();
                break;

            default:
                break;
        }

        this.setState({
            showIntervals: true,
            intervalsCommand: intervalsCommand,
            intervalsTripId: trip.id
        });
    }

    handleIntervalsExit(message = undefined) {
        if (undefined !== message && null !== message) {
            this.setState({
                alertTitle: message.title,
                alertMessage: message.message,
                icon: message.icon,
                alertStyle: message.style,
                showErrorModal: true
            });
        }

        this.setState({
            showIntervals: false,
            intervalsTripId: 0
        });
    }

    handleNotesClick(trip, type) {
        let notesCommand = undefined;
        switch (type) {
            case "active": notesCommand = new TripsCommand();
                break;

            case "draft": notesCommand = new TripsDraftCommand();
                break;

            default:
                break;
        }

        this.setState({
            showNotes: true,
            notesCommand: notesCommand,
            notesTripId: trip.id
        });
    }

    handleNotesExit(message = undefined) {
        if (undefined !== message && null !== message) {
            this.setState({
                alertTitle: message.title,
                alertMessage: message.message,
                icon: message.icon,
                alertStyle: message.style,
                showErrorModal: true
            });
        }

        this.setState({
            showNotes: false,
            notesTripId: 0,
        });
    }

    handleMoveClick(trip, type) {
        const { activeSchedules, draftSchedules } = this.state;
        let moveTripCommand = undefined;
        let schedules = undefined;
        let moveScheds = undefined;

        switch (type) {
            case "active":
                moveTripCommand = new TripsCommand();
                schedules = activeSchedules;
                moveScheds = schedules.filter((schedule) => schedule.id !== trip.schedule.id);
                break;

            case "draft":
                moveTripCommand = new TripsDraftCommand();
                schedules = draftSchedules;
                moveScheds = schedules.filter((schedule) => schedule.id !== trip.scheduleId);
                break;

            default:
                break;
        }

        this.setState({
            showMoveCopyModal: true,
            moveCommand: moveTripCommand,
            modalTripId: trip.id,
            moveableSchedules: moveScheds,
            modalCallback: (a, b) => this.moveTrip(a, b),
            modalTitleText: `Mover Viagem ${trip.name === undefined ? trip.code : trip.name}`,
            modalButtonText: 'Mover Viagem',
        });
    }

    handleCopyClick(trip, type) {
        const { activeSchedules, draftSchedules } = this.state;
        let copyTripCommand = undefined;
        let schedules = undefined;
        let moveScheds = undefined;

        switch (type) {
            case "active":
                copyTripCommand = new TripsCommand();
                schedules = activeSchedules;
                moveScheds = schedules.filter((schedule) => schedule.id !== trip.schedule.id);
                break;

            case "draft":
                copyTripCommand = new TripsDraftCommand();
                schedules = draftSchedules;
                moveScheds = schedules.filter((schedule) => schedule.id !== trip.scheduleId);
                break;

            default:
                break;
        }

        this.setState({
            showMoveCopyModal: true,
            copyCommand: copyTripCommand,
            modalTripId: trip.id,
            moveableSchedules: moveScheds,
            modalCallback: (a, b) => this.copyTrip(a, b),
            modalTitleText: `Copiar Viagem ${trip.name === undefined ? trip.code : trip.name}`,
            modalButtonText: 'Copiar Viagem',
        });
    }

    handleMoveExit(message = undefined) {
        if (undefined !== message && null !== message) {
            this.setState({
                alertTitle: message.title,
                alertMessage: message.message,
                icon: message.icon,
                alertStyle: message.style,
                showErrorModal: true
            });
        }

        this.setState({
            showMoveCopyModal: false,
            modalTripId: 0,
        });
    }

    onClickActivePropagateBtn() {
        const { activePathTrips, selectedPassing } = this.state;

        let time = selectedPassing.time.split(':');
        let initialTime = this.getDateObject(time[0], time[1], selectedPassing.time);

        time = activePathTrips[selectedPassing.tripPos].passings[selectedPassing.passPos].formatedHour.split(':');
        let newTime = this.getDateObject(time[0], time[1], activePathTrips[selectedPassing.tripPos].passings[selectedPassing.passPos].formatedHour);

        let minDiff = newTime - initialTime;
        if (!isNaN(minDiff)) {
            activePathTrips[selectedPassing.tripPos].passings.forEach((passing, i) => {
                this.updatePassingTime(selectedPassing, passing, i, minDiff);
            });

            this.setState({
                activePathTrips,
                justVerify: true,
                tripSelected: activePathTrips[selectedPassing.tripPos],
                selectedPassing: undefined
            },
                () => this.verifyActivePassings());
        }
    }

    onClickDraftPropagateBtn() {
        const { draftPathTrips, selectedPassing } = this.state;

        let time = selectedPassing.time.split(':');
        let initialTime = this.getDateObject(time[0], time[1], selectedPassing.time);

        time = draftPathTrips[selectedPassing.tripPos].passings[selectedPassing.passPos].formatedHour.split(':');
        let newTime = this.getDateObject(time[0], time[1], draftPathTrips[selectedPassing.tripPos].passings[selectedPassing.passPos].formatedHour);

        let minDiff = newTime - initialTime;
        if (!isNaN(minDiff)) {
            draftPathTrips[selectedPassing.tripPos].passings.forEach((passing, i) => {
                this.updatePassingTime(selectedPassing, passing, i, minDiff);
            });

            this.setState({
                draftPathTrips,
                justVerify: true,
                tripSelected: draftPathTrips[selectedPassing.tripPos],
                selectedPassing: undefined
            },
                () => this.verifyDraftPassings());
        }
    }

    // -------------------

    updatePassingTimeOnChange(isTime, pathTrip, passing, auxPassings, newTime, passingIdx) {
        let initialValue = passing.formatedHour;
        passing.formatedHour = newTime;

        if (isTime) {
            if (passingIdx !== 0) {
                auxPassings.splice(passingIdx, auxPassings.length - passingIdx);
                let indexLastValue = this.findLastIndex(auxPassings, 'time');

                if (this.checkPassingTimes(pathTrip.passings, passingIdx, indexLastValue)) {
                    let parsedTime = newTime.split(':');

                    passing.hour = parseInt(parsedTime[0], 10) * 1;
                    passing.minute = parseInt(parsedTime[1], 10) * 1;
                    passing.time = passing.hour * 60 + passing.minute;

                    this.setState({ showPropBtn: true });
                } else {
                    passing.formatedHour = initialValue;
                    this.setState({
                        alertTitle: "Aviso",
                        alertMessage: 'A hora tem de ser maior que a anterior',
                        alertStyle: 'warning',
                        icon: 'alert',
                        showErrorModal: true,
                        showPropBtn: false
                    })
                }
            } else {
                let parsedTime = newTime.split(':');

                passing.hour = parseInt(parsedTime[0], 10) * 1;
                passing.minute = parseInt(parsedTime[1], 10) * 1;
                passing.time = passing.hour * 60 + passing.minute;

                this.setState({ showPropBtn: true });
            }
        } else {
            if (newTime === "") {
                passing.hour = null;
                passing.minute = null;
                passing.time = null;
            } else {
                passing.hour = undefined;
                passing.minute = undefined;
                passing.time = undefined;
            }

            this.setState({ showPropBtn: false });
        }
    }

    updateTripsToChangeOnChangePassing(passId, tripsToChange, pathTripChanged) {
        if (passId !== undefined) {
            if (tripsToChange.length > 0) {
                let isNew = false;
                let index = tripsToChange.findIndex(t => t.id === pathTripChanged.id);
                if (index === -1) {
                    isNew = true;
                } else {
                    tripsToChange[index] = pathTripChanged;
                }

                if (isNew) {
                    tripsToChange.push(pathTripChanged);
                }
            }
            else {
                tripsToChange.push(pathTripChanged);
            }
        }
    }

    updatePassingTime(selectedPassing, passing, index, minDiff) {
        if (selectedPassing.passPos < index) {

            let date = passing.formatedHour.split(':');
            let d1 = this.getDateObject(date[0], date[1], passing.formatedHour);
            let d2 = new Date(d1 + minDiff);

            const newDateHours = "2" === `${d2.getDate()}` ? d2.getHours() + 24 : d2.getHours();
            const newDateMinutes = d2.getMinutes();

            passing.formatedHour = newDateHours + ":" + newDateMinutes;
            passing.hour = newDateHours;
            passing.minute = newDateMinutes;
            passing.time = Number(newDateHours * 60) + newDateMinutes;
        }
    }

    onChangeActivePassValue(passId, e) {
        const { activePathTrips, activeTripsToChange, selectedPassing } = this.state;
        let isTime = new RegExp("^(0[0-9]|1[0-9]|2[0-9]|[0-9]):[0-5][0-9]$").test(e.target.value);
        let pathTripChanged;
        let pass;

        activePathTrips.forEach((pathTrip, i) => {
            pathTrip.passings.forEach((passing, j) => {
                let auxPassings = [];
                auxPassings.push.apply(auxPassings, pathTrip.passings);

                if (passing.id === passId) {
                    pass = this.getPassingObject(selectedPassing, passId, passing, i, j);
                    this.updatePassingTimeOnChange(isTime, pathTrip, passing, auxPassings, e.target.value, j);
                    pathTripChanged = pathTrip;
                }
            });
        });

        this.updateTripsToChangeOnChangePassing(passId, activeTripsToChange, pathTripChanged);
        this.setState({ activePathTrips, activeTripsToChange, selectedPassing: pass !== undefined ? pass : selectedPassing });
    }

    onChangeDraftPassValue(passId, e) {
        const { draftPathTrips, draftTripsToChange, selectedPassing } = this.state;
        let isTime = new RegExp("^(0[0-9]|1[0-9]|2[0-9]|[0-9]):[0-5][0-9]$").test(e.target.value);
        let pathTripChanged;
        let pass;

        draftPathTrips.forEach((pathTrip, i) => {
            pathTrip.passings.forEach((passing, j) => {
                let auxPassings = [];
                auxPassings.push.apply(auxPassings, pathTrip.passings);

                if (passing.id === passId) {
                    pass = this.getPassingObject(selectedPassing, passId, passing, i, j);
                    this.updatePassingTimeOnChange(isTime, pathTrip, passing, auxPassings, e.target.value, j);
                    pathTripChanged = pathTrip;
                }
            });
        });

        this.updateTripsToChangeOnChangePassing(passId, draftTripsToChange, pathTripChanged);
        this.setState({ draftPathTrips, draftTripsToChange, selectedPassing: pass !== undefined ? pass : selectedPassing });
    }

    onChangeActiveTripName(tripId, e) {
        const { activePathTrips, activeTripsToChange } = this.state

        let pathTripChanged;

        activePathTrips.forEach((pathTrip, i) => {
            if (pathTrip.id === tripId) {
                pathTrip.name = e.target.value;
                pathTripChanged = pathTrip;
            }
        });

        if (tripId !== undefined) {
            if (activeTripsToChange.length > 0) {
                let isNew = false;
                let index = activeTripsToChange.findIndex(t => t.id === pathTripChanged.id);
                if (index === -1) {
                    isNew = true;
                } else {
                    activeTripsToChange[index] = pathTripChanged;
                }

                if (isNew) {
                    activeTripsToChange.push(pathTripChanged);
                }
            }
            else {
                activeTripsToChange.push(pathTripChanged);
            }
        }

        this.setState({ activePathTrips, activeTripsToChange });
    }

    onChangeDraftTripName(tripId, e) {
        const { draftPathTrips, draftTripsToChange } = this.state

        let pathTripChanged;

        draftPathTrips.forEach((pathTrip, i) => {
            if (pathTrip.id === tripId) {
                pathTrip.code = e.target.value;
                pathTripChanged = pathTrip;
            }
        });

        if (tripId !== undefined) {
            if (draftTripsToChange.length > 0) {
                let isNew = false;
                let index = draftTripsToChange.findIndex(t => t.id === pathTripChanged.id);
                if (index === -1) {
                    isNew = true;
                } else {
                    draftTripsToChange[index] = pathTripChanged;
                }

                if (isNew) {
                    draftTripsToChange.push(pathTripChanged);
                }
            }
            else {
                draftTripsToChange.push(pathTripChanged);
            }
        }

        this.setState({ draftPathTrips, draftTripsToChange });
    }

    onScheduleChange(sched) {
        this.setState({
            modalScheduleSelected: sched
        });
    }

    onPassTimeTypeChange(e, type) {
        switch (type) {
            case "isFreq":
                this.setState({
                    typeOfPass: type
                });
                break;
            case "freq":
                let freq = "";

                if (e.target.value.length < 2) {
                    freq = "0" + e.target.value;
                } else {
                    freq = e.target.value;
                }

                this.setState({
                    typeOfPass: type,
                    passFreq: freq
                });
                break;
            case "isClean":
                this.setState({
                    typeOfPass: type
                });
                break;
            default:
                this.setState({
                    alertTitle: "Aviso",
                    alertMessage: 'Tem de selecionar uma opção.',
                    alertStyle: 'warning',
                    icon: 'alert',
                    showErrorModal: true,
                    typeOfPass: "",
                    passFreq: "",
                })
                break;
        }
    }

    checkPassingTimes(passings, pos, lasValuePos) {
        if (-1 !== lasValuePos) {
            const currentTime = passings[pos].formatedHour.split(':');
            const beforeTime = passings[lasValuePos].formatedHour.split(':');

            if (this.getDateObject(currentTime[0], currentTime[1], passings[pos].formatedHour) >= this.getDateObject(beforeTime[0], beforeTime[1], passings[lasValuePos].formatedHour)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    validFreqValue(value) {
        let { freqInputError } = this.state;

        let errors = 0;
        freqInputError = null;

        if (isNaN(value) || value < 0 || value === "") {
            freqInputError = 'error';
            errors++;
        }

        this.setState({
            freqInputError
        })

        return errors > 0 ? false : true
    }

    // -------------------

    handleSelectTab(key) {
        this.setState({
            selectedTab: key
        });
    }

    toggleIsComparing() {
        const { isComparing } = this.state;

        this.setState({
            isComparing: !isComparing
        });
    }

    clearError() {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false,
        });
    }

    // -------------------

    cleanDraftPassing(pathStopId, pathStopOrder, idx, newTripId) {
        return {
            formatedHour: "",
            hour: null,
            id: Math.random() * (newTripId + [idx]),
            minute: null,
            pathStopId: pathStopId,
            pathStopOrder: pathStopOrder,
            time: null
        };
    }

    copyDraftPassing(passing, idx, newTripId, passFreq) {
        const d1 = this.getDateObject(passing.hour, passing.minute, passing.formatedHour);
        const d2 = new Date(d1 + Number(passFreq) * 1000 * 60);

        const newTimeHours = "2" === `${d2.getDate()}` ? d2.getHours() + 24 : d2.getHours();
        const newTimeMinutes = d2.getMinutes();

        return {
            formatedHour: `${1 === `${newTimeHours}`.length ? "0" : ""}${newTimeHours}:${1 === `${newTimeMinutes}`.length ? "0" : ""}${newTimeMinutes}`,
            hour: newTimeHours,
            id: Math.random() * (newTripId + [idx]),
            minute: newTimeMinutes,
            pathStopId: passing.pathStopId,
            pathStopOrder: passing.pathStopOrder,
            time: newTimeHours * 60 + newTimeMinutes
        };
    }

    onCreateDraftPassClick() {
        const { draftPathTrips, newTripId, draftPathSelectedPathStops, typeOfPass, passFreq, draftTripsToChange,
            draftScheduleSelected, draftPathSelected } = this.state;
        let newTrip = undefined;
        let newId = newTripId;
        let ex = false;

        if (draftPathTrips.length > 0) {
            const lastDraftPathTrip = draftPathTrips[draftPathTrips.length - 1];

            switch (typeOfPass) {
                case "isFreq":
                case "freq":
                    if (this.validFreqValue(passFreq)) {
                        const newPassings = lastDraftPathTrip.passings.map((passing, idx) =>
                            undefined === passing.time || null === passing.time || "" === passing.time ?
                                this.cleanDraftPassing(passing.pathStopId, passing.pathStopOrder, idx, newTripId) :
                                this.copyDraftPassing(passing, idx, newTripId, passFreq)
                        );

                        newTrip = {
                            id: newTripId,
                            networkEdition: draftPathSelected.networkEdition,
                            planningEdition: draftScheduleSelected.planningEdition,
                            name: "",
                            scheduleId: draftScheduleSelected.id,
                            pathId: draftPathSelected.id,
                            passings: newPassings
                        };
                    }
                    else {
                        ex = true;
                    }
                    break;
                case "isClean":
                    newTrip = {
                        id: newTripId,
                        networkEdition: draftPathSelected.networkEdition,
                        planningEdition: draftScheduleSelected.planningEdition,
                        name: "",
                        scheduleId: draftScheduleSelected.id,
                        pathId: draftPathSelected.id,
                        passings: lastDraftPathTrip.passings.map((passing, idx) => this.cleanDraftPassing(passing.pathStopId, passing.pathStopOrder, idx, newTripId))
                    };
                    break;
                default:
                    ex = true;
                    this.setState({
                        alertTitle: "Aviso",
                        alertMessage: 'Tem de selecionar uma opção.',
                        alertStyle: 'warning',
                        icon: 'alert',
                        showErrorModal: true,
                    });
                    break;
            }
        }
        else {
            if (draftPathSelectedPathStops.length > 0) {
                switch (typeOfPass) {
                    case "isFreq":
                    case "freq":
                        if (this.validFreqValue(passFreq)) {
                            let nextFrequence = Number(passFreq);
                            const newPassings = draftPathSelectedPathStops.map((pathStop, idx) => {
                                const passing = this.copyDraftPassing(
                                    { formatedHour: "00:00", pathStopId: pathStop.id }, idx, newTripId, nextFrequence
                                );

                                nextFrequence += 2;
                                return passing;
                            });

                            newTrip = {
                                id: newTripId,
                                networkEdition: draftPathSelected.networkEdition,
                                planningEdition: draftScheduleSelected.planningEdition,
                                name: "",
                                scheduleId: draftScheduleSelected.id,
                                pathId: draftPathSelected.id,
                                passings: newPassings
                            };
                        } else {
                            ex = true;
                        }
                        break;

                    case "isClean":
                        newTrip = {
                            id: newTripId,
                            networkEdition: draftPathSelected.networkEdition,
                            planningEdition: draftScheduleSelected.planningEdition,
                            name: "",
                            scheduleId: draftScheduleSelected.id,
                            pathId: draftPathSelected.id,
                            passings: draftPathSelectedPathStops.map((pathStop, idx) => this.cleanDraftPassing(pathStop.id, pathStop.stopOrder, idx, newTripId))
                        };
                        break;

                    default:
                        ex = true;
                        this.setState({
                            alertTitle: "Aviso",
                            alertMessage: 'Tem de selecionar uma opção.',
                            alertStyle: 'warning',
                            icon: 'alert',
                            showErrorModal: true
                        });
                        break;
                }
            }
        }

        if (!ex) {
            draftPathTrips.push(newTrip);
            draftTripsToChange.push(newTrip);
            newId--;

            this.setState({
                draftPathTrips,
                draftTripsToChange,
                newTripId: newId,
                showCreateModal: false,
                justVerify: true,
                typeOfPass: "",
                passFreq: 0
            }, () => this.verifyDraftPassings());
        }
    }

    cleanActivePassing(pathStop, idx, newTripId) {
        return {
            formatedHour: "",
            hour: null,
            id: Math.random() * (newTripId + [idx]),
            minute: null,
            pathStop: Object.assign({}, pathStop),
            time: null
        };
    }

    copyActivePassing(passing, idx, newTripId, passFreq) {
        const d1 = this.getDateObject(passing.hour, passing.minute, passing.formatedHour);
        const d2 = new Date(d1 + Number(passFreq) * 1000 * 60);

        const newTimeHours = "2" === `${d2.getDate()}` ? d2.getHours() + 24 : d2.getHours();
        const newTimeMinutes = d2.getMinutes();

        return {
            formatedHour: `${1 === `${newTimeHours}`.length ? "0" : ""}${newTimeHours}:${1 === `${newTimeMinutes}`.length ? "0" : ""}${newTimeMinutes}`,
            hour: newTimeHours,
            id: Math.random() * (newTripId + [idx]),
            minute: newTimeMinutes,
            pathStop: Object.assign({}, passing.pathStop),
            time: newTimeHours * 60 + newTimeMinutes
        };
    }

    onCreateActivePassClick() {
        const { activePathTrips, newTripId, activePathSelectedPathStops, typeOfPass, passFreq, activeTripsToChange,
            activeScheduleSelected, activePathSelected } = this.state;
        let newTrip = undefined;
        let newId = newTripId;
        let ex = false;

        if (activePathTrips.length > 0) {
            const lastActivePathTrip = activePathTrips[activePathTrips.length - 1];

            switch (typeOfPass) {
                case "isFreq":
                case "freq":
                    if (this.validFreqValue(passFreq)) {
                        const newPassings = lastActivePathTrip.passings.map((passing, idx) =>
                            undefined === passing.time || null === passing.time || "" === passing.time ?
                                this.cleanActivePassing(passing.pathStop, idx, newTripId) :
                                this.copyActivePassing(passing, idx, newTripId, passFreq)
                        );

                        newTrip = {
                            id: newTripId,
                            networkEdition: activePathSelected.networkEdition,
                            planningEdition: activeScheduleSelected.planningEdition,
                            name: "",
                            schedule: activeScheduleSelected,
                            path: activePathSelected,
                            passings: newPassings
                        };
                    }
                    else {
                        ex = true;
                    }
                    break;
                case "isClean":
                    newTrip = {
                        id: newTripId,
                        networkEdition: activePathSelected.networkEdition,
                        planningEdition: activeScheduleSelected.planningEdition,
                        name: "",
                        schedule: activeScheduleSelected,
                        path: activePathSelected,
                        passings: lastActivePathTrip.passings.map((passing, idx) => this.cleanActivePassing(passing.pathStop, idx, newTripId))
                    };
                    break;
                default:
                    ex = true;
                    this.setState({
                        alertTitle: "Aviso",
                        alertMessage: 'Tem de selecionar uma opção.',
                        alertStyle: 'warning',
                        icon: 'alert',
                        showErrorModal: true,
                    });
                    break;
            }
        }
        else {
            if (activePathSelectedPathStops.length > 0) {
                switch (typeOfPass) {
                    case "isFreq":
                    case "freq":
                        if (this.validFreqValue(passFreq)) {
                            let nextFrequence = Number(passFreq);
                            const newPassings = activePathSelectedPathStops.map((pathStop, idx) => {
                                const passing = this.copyActivePassing(
                                    { formatedHour: "00:00", pathStop: pathStop }, idx, newTripId, nextFrequence
                                );

                                nextFrequence += 2;
                                return passing;
                            });

                            newTrip = {
                                id: newTripId,
                                networkEdition: activePathSelected.networkEdition,
                                planningEdition: activeScheduleSelected.planningEdition,
                                name: "",
                                schedule: activeScheduleSelected,
                                path: activePathSelected,
                                passings: newPassings
                            };
                        } else {
                            ex = true;
                        }
                        break;

                    case "isClean":
                        newTrip = {
                            id: newTripId,
                            networkEdition: activePathSelected.networkEdition,
                            planningEdition: activeScheduleSelected.planningEdition,
                            name: "",
                            schedule: activeScheduleSelected,
                            path: activePathSelected,
                            passings: activePathSelectedPathStops.map((pathStop, idx) => this.cleanActivePassing(pathStop, idx, newTripId))
                        };
                        break;

                    default:
                        ex = true;
                        this.setState({
                            alertTitle: "Aviso",
                            alertMessage: 'Tem de selecionar uma opção.',
                            alertStyle: 'warning',
                            icon: 'alert',
                            showErrorModal: true
                        });
                        break;
                }
            }
        }

        if (!ex) {
            activePathTrips.push(newTrip);
            activeTripsToChange.push(newTrip);
            newId--;

            this.setState({
                activePathTrips,
                activeTripsToChange,
                newTripId: newId,
                showCreateModal: false,
                justVerify: true,
                typeOfPass: "",
                passFreq: 0
            }, () => this.verifyActivePassings());
        }
    }

    pathTripsSort(a, b) {
        const commumStops = a.passings.filter(aPassing =>
            undefined !== aPassing.time && (
                b.passings.find(bPassing =>
                    undefined !== bPassing.time && (bPassing.pathStopId === aPassing.pathStopId || (undefined !== bPassing.pathStop && bPassing.pathStop.Id === aPassing.pathStop.id))
                )
            )
        )
            .map(passing => undefined === passing.pathStop ? passing.pathStopId : passing.pathStop.id);

        let passingA = a.passings.sort((x, y) => undefined === x.pathStop ? x.pathStopOrder - y.pathStopOrder : x.pathStop.order - y.pathStop.order)
            .find(x => x.time !== undefined && (undefined === x.pathStop ? commumStops.includes(x.pathStopId) : commumStops.includes(x.pathStop.id)));
        let passingB = b.passings.sort((x, y) => undefined === x.pathStop ? x.pathStopOrder - y.pathStopOrder : x.pathStop.order - y.pathStop.order)
            .find(x => x.time !== undefined && (undefined === x.pathStop ? commumStops.includes(x.pathStopId) : commumStops.includes(x.pathStop.id)));

        if (undefined === passingA && undefined === passingB) {
            passingA = a.passings.find(x => x.time !== undefined);
            passingB = b.passings.find(x => x.time !== undefined);
        }

        if (undefined === passingA) {
            return -1;
        }

        if (undefined === passingB) {
            return 1;
        }

        return passingA.time - passingB.time;
    }

    orderListActive(whichList) {
        if (whichList === 'pathSelectedPathStops') {
            const { activePathSelectedPathStops } = this.state;

            this.setState({
                activePathSelectedPathStops: activePathSelectedPathStops.sort((a, b) => a.stopOrder - b.stopOrder)
            });
        } else {
            const { activePathTrips, activePathSelectedPathStops } = this.state;
            let updateState = false;

            if (activePathTrips !== undefined && activePathTrips.length !== 0) {
                activePathTrips.forEach((pathTrip, idx) => {
                    if (pathTrip.passings.length < activePathSelectedPathStops.length) {
                        activePathSelectedPathStops.forEach((pathStop) => {
                            if (undefined === pathTrip.passings.find(passing => passing.pathStop.id === pathStop.id)) {
                                pathTrip.passings.push({
                                    id: Math.random() * (this.state.newTripId - idx) - 1,
                                    formatedHour: "",
                                    hour: null,
                                    minute: null,
                                    pathStop: {
                                        id: pathStop.id,
                                        prevDistance: pathStop.prevDistance,
                                        restriction: pathStop.restriction,
                                        segmentBreakDuration: pathStop.segmentBreakDuration,
                                        stopOrder: pathStop.stopOrder
                                    },
                                    time: null
                                });
                            }
                        });
                    }

                    pathTrip.passings.sort((a, b) => a.pathStop.stopOrder - b.pathStop.stopOrder);
                });

                activePathTrips.sort((a, b) => this.pathTripsSort(Object.assign({}, a), Object.assign({}, b)));
                updateState = true;
            }

            if (updateState) {
                this.setState({
                    activePathTrips: activePathTrips,
                    renderTable: true
                });
            }
        }
    }

    orderListDraft(whichList) {
        if (whichList === 'pathSelectedPathStops') {
            const { draftPathSelectedPathStops } = this.state;

            this.setState({
                draftPathSelectedPathStops: draftPathSelectedPathStops.sort((a, b) => a.stopOrder - b.stopOrder)
            });
        } else {
            const { draftPathTrips, draftPathSelectedPathStops } = this.state;
            let updateState = false;

            if (Array.isArray(draftPathTrips) && draftPathTrips.length !== 0) {
                draftPathTrips.forEach((pathTrip, idx) => {
                    if (pathTrip.passings.length < draftPathSelectedPathStops.length) {
                        draftPathSelectedPathStops.forEach((pathStop) => {
                            if (undefined === pathTrip.passings.find(passing => passing.pathStop.id === pathStop.id)) {
                                pathTrip.passings.push({
                                    id: Math.random() * (this.state.newTripId - idx) - 1,
                                    formatedHour: "",
                                    hour: null,
                                    minute: null,
                                    pathStopId: pathStop.id,
                                    pathStopOrder: pathStop.stopOrder,
                                    time: null
                                });
                            }
                        });

                        pathTrip.passings.sort((a, b) => a.pathStopOrder - b.pathStopOrder);
                    }
                });

                draftPathTrips.sort((a, b) => this.pathTripsSort(Object.assign({}, a), Object.assign({}, b)));
                updateState = true;
            }

            if (updateState) {
                this.setState({
                    draftPathTrips,
                    renderTable: true,
                    loadingDraftTrips: false
                });
            }
        }
    }

    getPassingObject(selectedPassing, passId, passing, tripIdx, passingIdx) {
        let pass;

        if (selectedPassing === undefined) {
            pass = {
                tripPos: tripIdx,
                passPos: passingIdx,
                id: passing.id,
                time: passing.formatedHour
            };
        } else {
            if (selectedPassing.id !== passId) {
                pass = {
                    tripPos: tripIdx,
                    passPos: passingIdx,
                    id: passing.id,
                    time: passing.formatedHour
                };
            }
        }

        return pass;
    }

    findLastIndex(array, searchKey) {
        let index = array.slice().reverse().findIndex(x => null !== x[searchKey] && undefined !== x[searchKey]);
        let count = array.length - 1
        let finalIndex = index >= 0 ? count - index : index;

        return finalIndex;
    }

    getDateObject(hour, minute, formattedHour) {
        let date = "";

        if (hour >= 24) {
            let timeDif = hour - 24;

            if (timeDif.toString().length > 1) {
                date = "01/02/2001 " + timeDif + ":" + minute + ":00";
            } else {
                date = "01/02/2001 0" + timeDif + ":" + minute + ":00";
            }
        } else {
            const parsedFormattedHour = undefined === formattedHour || null === formattedHour || "" === formattedHour || ":" === formattedHour ? "00:00" : formattedHour;

            date = "01/01/2001 " + parsedFormattedHour + ":00";
        }

        return Date.parse(date);
    }

    // -------------------

    getDraftTripsToCompare(lineSelected, pathSelected, scheduleSelected) {
        if (undefined === pathSelected || undefined === scheduleSelected) {
            return [];
        }

        const { draftCompareTrips } = this.state;

        return draftCompareTrips.filter(dt => dt.scheduleCode === scheduleSelected.name && dt.pathCode === pathSelected.code && dt.lineCode === lineSelected.code);
    }

    getDraftPathStopsToCompare(lineSelected, pathSelected) {
        if (undefined === lineSelected || undefined === pathSelected) {
            return [];
        }

        const { draftComparePathStops } = this.state;

        return draftComparePathStops.filter(dps => dps.pathCode === pathSelected.code && dps.lineCode === lineSelected.code);
    }

    renderPassingTimesActive() {
        const { actionsActive, isComparing, activeLines, activeLinePaths, activePathTrips, activeSchedules,
            activeLineSelected, activePathSelected, activePathSelectedPathStops, activeScheduleSelected,
            selectedPassing, editTripName, showPropBtn } = this.state;

        let pathTrips;
        let pathStops;
        if (isComparing) {
            pathTrips = ComparisonHelper.compare(
                activePathTrips,
                this.getDraftTripsToCompare(activeLineSelected, activePathSelected, activeScheduleSelected),
                {
                    match: [{ left: "name", right: "code" }],
                    fields: [{ left: "passings", right: "passings" }]
                });

            pathStops = ComparisonHelper.compare(
                activePathSelectedPathStops,
                this.getDraftPathStopsToCompare(activeLineSelected, activePathSelected),
                {
                    match: [{ left: "stopOrder", right: "stopOrder" }],
                    fields: [{ left: "stop.name", right: "stopName" }, { left: "stop.code", right: "stopCode" }]
                });
        }
        else {
            pathTrips = activePathTrips;
            pathStops = activePathSelectedPathStops;
        }

        return (
            <PassingTimesActive lines={activeLines}
                linePaths={activeLinePaths}
                schedules={activeSchedules}
                pathTrips={pathTrips}
                lineSelected={activeLineSelected}
                pathSelected={activePathSelected}
                pathSelectedPathStops={pathStops}
                scheduleSelected={activeScheduleSelected}
                selectedPassing={selectedPassing}
                editTripName={editTripName}
                loadingLines={actionsActive.loadingLines}
                loadingPathStops={actionsActive.loadingPathStops}
                loadingTrips={actionsActive.loadingTrips}
                handleLineSelected={(a) => this.handleActiveLineSelected(a)}
                handlePathSelected={(a) => this.handleActivePathSelected(a)}
                handleScheduleSelected={(a) => this.handleActiveScheduleSelected(a)}
                onChangeTripName={(a, b) => this.onChangeActiveTripName(a, b)}
                onDoubleClickTrip={(a, b) => this.onDoubleClickTrip(a, b)}
                onClickPropagateBtn={() => this.onClickActivePropagateBtn()}
                onChangePassValue={(a, b) => this.onChangeActivePassValue(a, b)}
                handleCreateClick={() => this.handleCreateClick("active")}
                handleDeleteClick={(a, b) => this.handleDeleteClick(a, b)}
                handleIntervalsClick={(a) => this.handleIntervalsClick(a, "active")}
                handleMoveClick={(a) => this.handleMoveClick(a, "active")}
                handleCopyClick={(a) => this.handleCopyClick(a, "active")}
                handleNotesClick={(a) => this.handleNotesClick(a, "active")}
                showPropBtn={showPropBtn} />
        );
    }

    renderPassingTimesDraft() {
        const { actionsDraft, draftLines, draftLinePaths, draftPathTrips, draftSchedules, draftLineSelected,
            draftPathSelected, draftPathSelectedPathStops, draftScheduleSelected, selectedPassing,
            editTripName } = this.state;

        if (actionsDraft.loadingLines) {
            return (<LoadingSpinner />)
        }

        return (
            <PassingTimesDraft lines={draftLines}
                linePaths={draftLinePaths}
                schedules={draftSchedules}
                pathTrips={draftPathTrips}
                lineSelected={draftLineSelected}
                pathSelected={draftPathSelected}
                pathSelectedPathStops={draftPathSelectedPathStops}
                scheduleSelected={draftScheduleSelected}
                selectedPassing={selectedPassing}
                editTripName={editTripName}
                loadingLines={actionsDraft.loadingLines}
                loadingPaths={actionsDraft.loadingPaths}
                loadingPathStops={actionsDraft.loadingPathStops}
                loadingTrips={actionsDraft.loadingTrips}
                handleLineSelected={(a) => this.handleDraftLineSelected(a)}
                handlePathSelected={(a) => this.handleDraftPathSelected(a)}
                handleScheduleSelected={(a) => this.handleDraftScheduleSelected(a)}
                onChangeTripName={(a, b) => this.onChangeDraftTripName(a, b)}
                onDoubleClickTrip={(a, b) => this.onDoubleClickTrip(a, b)}
                onClickPropagateBtn={() => this.onClickDraftPropagateBtn()}
                onChangePassValue={(a, b) => this.onChangeDraftPassValue(a, b)}
                handleCreateClick={() => this.handleCreateClick("draft")}
                handleDeleteClick={(a, b) => this.handleDeleteClick(a, b)}
                handleIntervalsClick={(a) => this.handleIntervalsClick(a, "draft")}
                handleMoveClick={(a) => this.handleMoveClick(a, "draft")}
                handleCopyClick={(a) => this.handleCopyClick(a, "draft")}
                handleNotesClick={(a) => this.handleNotesClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { isComparing } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={isComparing}
                            icons={false}
                            onChange={() => this.toggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderPassingTimes(selectedTab) {
        return (
            <div className="tab-with-options margin-top-15">
                <Tabs id="datamanger_tabs" activeKey={selectedTab} onSelect={(a) => this.handleSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderPassingTimesActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderPassingTimesDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(selectedTab)}
            </div>
        );
    }

    renderIntervals() {
        const { showIntervals, intervalsTripId, intervalsCommand } = this.state;
        const { edition } = this.context;

        if (!showIntervals) {
            return null;
        }

        return (
            <Intervals edition={edition}
                elementId={intervalsTripId}
                command={intervalsCommand}
                onHide={(a) => this.handleIntervalsExit(a)} />
        );
    }

    renderNotes() {
        const { showNotes, notesTripId, notesCommand } = this.state;
        const { edition } = this.context;

        if (!showNotes) {
            return null;
        }

        return (
            <TripNotes edition={edition}
                elementId={notesTripId}
                command={notesCommand}
                onHide={(a) => this.handleNotesExit(a)} />
        );
    }

    moveTrip(tripId, newSched) {
        const { activeTripsToChange, draftTripsToChange, moveCommand, activeScheduleSelected, draftScheduleSelected, selectedTab } = this.state;

        if (undefined === newSched) {
            this.setState({
                showExecutingModal: false,
                alertTitle: "Aviso",
                alertMessage: 'Selecione um horário de destino!',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            });

            return;
        }

        const wasTripChanged = activeTripsToChange.some((trip) => trip.id === tripId) || draftTripsToChange.some((trip) => trip.id === tripId);

        if (wasTripChanged) {
            this.setState({
                showExecutingModal: false,
                alertTitle: "Aviso",
                alertMessage: 'Existem alterações pendentes. Guarde as alterações antes de mover a viagem',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            });

            return;
        }

        this.setState({
            showMoveCopyModal: false,
            modalTripId: 0,
            modalScheduleSelected: undefined,
            showExecutingModal: true,
            modalCallback: undefined,
            modalTitleText: '',
            modalButtonText: '',
        });


        moveCommand.moveTrip(newSched, tripId, this.context.edition.network,
            "draft" === selectedTab ? draftScheduleSelected.planningEdition : activeScheduleSelected.planningEdition,
            (a) => this.moveTripSuccessfulCallback(a, "move"),
            (a) => this.moveTripErrorCallback(a));
    }

    copyTrip(tripId, newSched) {
        const { activeTripsToChange, draftTripsToChange, copyCommand, activeScheduleSelected, draftScheduleSelected, selectedTab } = this.state;
        if (undefined === newSched) {
            this.setState({
                showExecutingModal: false,
                alertTitle: "Aviso",
                alertMessage: 'Selecione um novo horário',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            });

            return;
        }

        const wasTripChanged = activeTripsToChange.some((trip) => trip.id === tripId) || draftTripsToChange.some((trip) => trip.id === tripId);

        if (wasTripChanged) {
            this.setState({
                showExecutingModal: false,
                alertTitle: "Aviso",
                alertMessage: 'Existem alterações pendentes. Guarde as alterações antes de copiar a viagem',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            });

            return;
        }

        this.setState({
            showMoveCopyModal: false,
            modalTripId: 0,
            modalScheduleSelected: undefined,
            showExecutingModal: true,
            modalCallback: undefined,
            modalTitleText: '',
            modalButtonText: '',
        });

        copyCommand.copyTrip(newSched, tripId, this.context.edition.network,
            "draft" === selectedTab ? draftScheduleSelected.planningEdition : activeScheduleSelected.planningEdition,
            (a) => this.moveTripSuccessfulCallback(a, "copy"),
            (a) => this.moveTripErrorCallback(a));
    }


    onExitModal() {
        this.setState({
            showMoveCopyModal: false,
            modalTripId: 0,
            modalScheduleSelected: undefined,
            modalTitleText: '',
            modalButtonText: '',
        });
    }

    moveTripSuccessfulCallback(result, type) {
        // ADICIONAR ESTA VIAGEM A UMA LISTA DE VIAGENS PARA NAO APARECER
        const { selectedTab } = this.state;
        const { edition } = this.context;

        if ("move" === type) {
            if ("draft" === selectedTab) {
                this.getDraftTrips(edition);
            }
            else {
                this.getActiveTrips(edition);
            }
        }

        this.setState({
            showExecutingModal: false,
            showErrorModal: true,
            alertTitle: "Sucesso",
            alertMessage: 'Alterações efetuadas com sucesso.',
            alertStyle: 'success',
            icon: 'ok',
        });
    }

    moveTripErrorCallback(messageReceived) {
        this.setState({
            showExecutingModal: false,
            alertTitle: "Erro",
            alertMessage: messageReceived,
            alertStyle: 'danger',
            icon: 'remove',
            showErrorModal: true,
        });
    }

    renderTripModal() {
        const { showMoveCopyModal, modalTripId, moveableSchedules, modalScheduleSelected,
            modalButtonText, modalTitleText, modalCallback } = this.state;
        const { edition } = this.context;

        if (!showMoveCopyModal) {
            return null;
        }

        return (
            <Modal show={true} bsSize="large">
                <Modal.Header>
                    <Modal.Title>{modalTitleText}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Row>
                            <Col sm={12}>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Selecionar horário de destino</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {
                                                    <Select
                                                        className="custom-multiselect"
                                                        placeholder="Selecione um horário..."
                                                        noOptionsMessage={() => "Sem Horários Configurados"}
                                                        onChange={(e) => this.onScheduleChange(e)}
                                                        options={moveableSchedules}
                                                        isMulti={false}
                                                        isClearable={true}
                                                        getOptionValue={value => value.id}
                                                        getOptionLabel={label => `${label.name} ««${edition.getPlanningEditionName(label.planningEdition)}»»`}
                                                        value={undefined === modalScheduleSelected ? null : modalScheduleSelected}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Grid>
                    <ButtonToolbar>
                        <Button onClick={() => modalCallback(modalTripId, modalScheduleSelected)}> {modalButtonText} </Button>
                        <Button onClick={() => this.onExitModal()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { selectedTab, loadingEdition, formType } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Tempos de Passagem" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.save()}>GUARDAR ALTERAÇÕES</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderPassingTimes(selectedTab)}

                <PassingTimesForm show={this.state.showCreateModal}
                    typeOfPass={this.state.typeOfPass}
                    onChangeValue={(a, b) => this.onPassTimeTypeChange(a, b)}
                    freqInputError={this.state.freqInputError}
                    onSave={() => "active" === formType ? this.onCreateActivePassClick() : this.onCreateDraftPassClick()}
                    onHide={() => this.handleCancelClick()} />

                <HandleDialog show={this.state.showDeleteModal}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    argument={this.state.alertArgument}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    onExit={(a, b) => this.deleteTrip(a, b)} />

                <HandleMessage show={this.state.showErrorModal}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    onHide={() => this.clearError()} />

                <HandleMessage show={this.state.showExecutingModal}
                    title={this.state.executingTitle}
                    message={this.state.executingMessage}
                    icon={this.state.exectuingIcon}
                    style={this.state.executingStyle}
                    onHide={() => this.clearError()}
                    small
                    noButtons />

                <HandleMessage
                    title="A Carregar a Edição..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={loadingEdition}
                    small
                    noButtons />

                {this.renderIntervals()}
                {this.renderNotes()}
                {this.renderTripModal()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/passingTimes/PassingTimes.js